import { TournamentGoalkeepersPage } from "@/pages/tournament/goalkeepers/page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_pathlessLayout/tournament/goalkeepers")({
    component: TournamentGoalkeepersPage,
});
